import React from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';

interface IProps {
	to: string;
	replace?: boolean;
	state?: any;
}

const Redirect: React.FC<IProps> = ({ to, replace, state }) => {
	const params = useParams();
	const redirectWithParams = generatePath(to, params);

	return <Navigate to={redirectWithParams} replace={replace} state={state} />;
};

Redirect.defaultProps = {
	replace: false,
	state: {}
};

export default Redirect;
